
export default function Stars (props) {
    let textCol = 'var(--ltg)'
    const {textColor,offset,qty,id} = props
    if(textColor){textCol = textColor}
    return(
        <div style={{flexDirection:"row",alignItems:'flex-start'}}>
            <svg height='20' width="119" viewBox="0 0 168 28" stroke='var(--org)' strokeWidth="1">
                <path
                    fill={`url(#${id})`}
                    d="M15 0L18 10H29L20.5 17L24 27L15 21L6 27L9.5 17L1 10H12L15 0Z
                    M50 0L53 10H63L55.5 17L59 27L50 21L41 27L44.5 17L36 10H47L50 0Z
                    M85 0L88 10H98L90.5 17L94 27L85 21L76 27L79.5 17L71 10H82L85 0Z
                    M120 0L123 10H133L125.5 17L129 27L120 21L111 27L114.5 17L106 10H117L120 0Z
                    M155 0L158 10H168L160.5 17L164 27L155 21L146 27L149.5 17L141 10H152L155 0Z"
                />
                <defs>
                    <linearGradient id={id}>
                    <stop stopColor='var(--org)' offset="0"/>
                    <stop stopColor='var(--org)' offset={offset ? offset : '0'}/>
                    <stop stopColor='var(--drg)' offset={offset ? offset : '0'}/>
                    <stop stopColor='var(--drg)'  offset="1"/>
                    </linearGradient>
                </defs>
            </svg>
            {qty > 0 && <p style={{marginLeft:5,fontSize:18,color:textCol}}>{qty}</p>}
        </div>
    )
}